import { useContext, useEffect } from 'react'
import { useParams, withRouter } from 'react-router-dom'
import * as H from 'history'
import { ContentBody, ContentHeader } from 'components/shared/content'
import { ExTable, TableBody, TableCell, TableHead, TableRow, TableWrapper } from 'components/shared/widget'
import { CreateCouponCodeForm, useCreateCouponCodesApi } from 'api/coupon'
import { useEffectSkipFirst, useForm, useQuery } from 'utils/hooks'
import { GlobalStateContext } from 'contexts/global_state_context'
import { InputField } from 'components/shared/input'
import { useState } from 'react'
import { Button, Modal, ModalBody, ModalFooter, ModalTitle, ProgressBar } from 'react-bootstrap'
import ModalHeader from 'react-bootstrap/esm/ModalHeader'
import { Group } from 'entities'
import { CouponCodeGroupBySearchForm } from 'entities/coupon_code'
import { Flex } from 'components/shared/flex'
import { useGroupApi } from 'api/group_by'

type Props = {
    history: H.History
}

const CouponsPage = (props: Props) => {
    const globalState = useContext(GlobalStateContext)
    const params = useParams<{ id: string }>()
    const query = useQuery<CouponCodeGroupBySearchForm & { couponName: string }>()
    const allSearchForm = useForm<CouponCodeGroupBySearchForm>({ groupBy: 'issued_date', aggregate: 'Count("issued_date")' })
    const receiveSearchForm = useForm<CouponCodeGroupBySearchForm>({
        groupBy: 'issued_date',
        aggregate: 'Count("issued_date")',
        aggregateAlias: 'count',
        nonSample: true,
    })
    const allCountApi = useGroupApi('coupon_codes', allSearchForm)
    const receiveCountApi = useGroupApi('coupon_codes', receiveSearchForm)
    const [showIssueModal, setShowIssueModal] = useState<boolean>(false)
    const postApi = useCreateCouponCodesApi()
    const form = useForm<CreateCouponCodeForm>({})

    useEffect(() => {
        allCountApi.execute()
        receiveCountApi.execute()
    }, [])

    useEffectSkipFirst(() => {
        globalState.setLoading(postApi.loading)
        if (postApi.isSuccess()) {
            allCountApi.execute()
            receiveCountApi.execute()
            setShowIssueModal(false)
        }
    }, [postApi.loading])

    return (
        <>
            <Modal show={showIssueModal} onHide={() => setShowIssueModal(false)}>
                <ModalHeader closeButton>
                    <ModalTitle>クーポンコード発行</ModalTitle>
                </ModalHeader>
                <ModalBody>
                    <InputField form={form} attr="count" type="number" min={1} label="発行数" />
                </ModalBody>
                <ModalFooter>
                    <Button
                        variant="secondary"
                        onClick={() => {
                            setShowIssueModal(false)
                        }}
                    >
                        閉じる
                    </Button>
                    <Button
                        variant="success"
                        onClick={() => {
                            postApi.execute(Number(params.id), form)
                        }}
                    >
                        発行
                    </Button>
                </ModalFooter>
            </Modal>
            <ContentHeader
                headerTitle={`${query.couponName} - クーポンコード一覧`}
                left={
                    <>
                        {/* <CopyTableButton /> */}
                        <Button
                            variant="success"
                            onClick={() => {
                                setShowIssueModal(true)
                            }}
                        >
                            コード発行
                        </Button>
                    </>
                }
                right={<>{/* <DisplaySettingModal displaySettings={displaySettings} /> */}</>}
            />
            <ContentBody>
                <TableWrapper contentHeaderCount={1}>
                    <ExTable className="sticky-table">
                        <TableHead>
                            <TableRow>
                                <TableCell align="center" th width={100}>
                                    発行日
                                </TableCell>
                                <TableCell th minWidth={200}>
                                    発行数
                                </TableCell>
                                <TableCell th width={120}></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody loading={allCountApi.loading} columnLength={3}>
                            {allCountApi.response.groups.map((group: Group, index) => {
                                const receiveCount = receiveCountApi.response.groups.find((g) => g['issuedDate'] === group['issuedDate']) || {}
                                return (
                                    <TableRow key={`coupon-code-histories-${index}`}>
                                        <TableCell align="center">{group['issuedDate']}</TableCell>
                                        <TableCell>
                                            <Flex alignItems="center">
                                                <ProgressBar max={group['count']} now={receiveCount['count'] || 0} style={{ flexGrow: 1 }} />
                                                <div style={{ marginLeft: 10 }}>
                                                    {receiveCount['count'] || 0} / {group['count']}
                                                </div>
                                            </Flex>
                                        </TableCell>
                                        <TableCell align="center">
                                            <Button
                                                variant="secondary"
                                                size="sm"
                                                onClick={() => {
                                                    props.history.push(`/coupons/${params.id}/codes?issued_date=${group['issuedDate']}`)
                                                }}
                                            >
                                                コード印刷
                                            </Button>
                                        </TableCell>
                                    </TableRow>
                                )
                            })}
                        </TableBody>
                    </ExTable>
                </TableWrapper>
            </ContentBody>

            {/* <SelectionFixedFooter
                ids={checkIdForm.ids()}
                onClickReset={() => checkIdForm.form.resetForm()}
                searchForm={searchForm}
                searchAttr="id"
                tableName="Coupon"
            ></SelectionFixedFooter> */}
        </>
    )
}

export default withRouter(CouponsPage)
